import type { IOptionItem } from '~/client/src/shared/components/OptionsList/types'
import { IResourceFieldCatalog } from '~/client/src/shared/resources/catalog/types'
import { compareLabelsAlphanumeric } from '~/client/src/shared/utils/compareGroupsByLabel'

export function buildMobileGroupingOptions(
  fieldCatalog: IResourceFieldCatalog,
): IOptionItem[] {
  return fieldCatalog.groupableFields
    .map(field => ({
      key: field.key,
      label: field.label,
      glyph: field.glyph,
    }))
    .sort((a, b) => compareLabelsAlphanumeric(a.label, b.label))
}

export function buildMobileSortOptions(
  fieldCatalog: IResourceFieldCatalog,
): IOptionItem[] {
  return fieldCatalog.sortableFields
    .map(field => ({
      key: field.key,
      label: field.label,
      glyph: field.glyph,
    }))
    .sort((a, b) => compareLabelsAlphanumeric(a.label, b.label))
}
